import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VirtualClassModel } from 'src/app/core/models/virtual-class.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { CommonFunctionsService } from 'src/app/core/services/common-functions.service';
import { VirtualClassService } from 'src/app/core/services/virtual-class.service';

declare var $: any;
declare var ConnectToServer: any;
declare var unload: any;
declare var switchVideo: any;
declare var initializeJitsi: any;
declare var SendMessageToAllParticipants: any;
declare var ToggleVideo: any;
declare var roomId: any;
declare var JitsiMeetJS: any;
declare var onLocalTracks: any;

@Component({
  selector: 'app-room',
  templateUrl: './room.component.html',
  styleUrls: ['./room.component.scss']
})
export class RoomComponent implements OnInit, AfterViewInit {

  public id: string = '-1';
  virtualClassModel: VirtualClassModel = new VirtualClassModel;
  isJoined = false;
  NumberOfStudents = 0;
  messages = [];
  participants = [];
  remoteUsers = [];
  message = "";
  isInstructor: boolean = false;

  connector = {
    token: '',
    roomId: '',
    displayName: '',
    onConnectionSuccess: () => {
      console.log('Connected to room: ' + '');
    },
    onConnectionFailed: () => {
      console.log('Connection failed');
    },
    onConferenceJoined: (myId: string) => {
      this.isJoined = true;
      console.log('Join success');
    },
    onDisconnect: () => {
      this.isJoined = false;
      console.log('Disconnected');
      close();
    },
    onUserJoined: (participants: any, remoteUsers: any) => {
      this.NumberOfStudents = participants.length;
      this.participants =  participants;  
      //this.remoteUsers = remoteUsers;
    },
    onUserLeft: (participants: any, remoteUsers: any) => {
      this.NumberOfStudents = participants.length;
      this.participants =  participants;
      //this.remoteUsers = remoteUsers;
    },
    onRoomTrackAdded: () => {

    },
    onMessageReceived: (message: any) => {
      this.messages.push(message);
    }
  }

  constructor(private virtualClassService: VirtualClassService, 
    public route: ActivatedRoute,
    public commonFunctionsService: CommonFunctionsService,
    public authService: AuthService){
      this.isInstructor = this.authService.hasRole('INSTRUCTOR');
    }

  ngOnInit() {
    this.route.params.subscribe(params => this.id = params.id);
  }

  ngAfterViewInit(): void {
    
    this.virtualClassService.get(this.id)
      .subscribe(
        result => {
          if(result.Success){
            this.virtualClassModel = result.data;
            this.connector.token = (result as any).token;
            console.log(this.connector);
            
            this.initializeConference();
          }
          else{
            this.commonFunctionsService.showNotification('error', 'İlgili sanal sınıf bulunamadı!', true);
          }
        },
        error => {
          this.commonFunctionsService.showNotification('error', 'İlgili sanal sınıf bulunamadı!', true);
        }
      )
    
      $('[data-toggle="tooltip"]').tooltip({ trigger: "hover" });


  }

  initializeConference(){
    this.connector.displayName = this.authService.getUserName();
    this.connector.roomId = this.virtualClassModel.VirtualClassRoomName;

    initializeJitsi(this.connector);

    $('#test-unload').on('click', function () {
      $('#jetsinif-tracks > .col-md-6').fadeOut('slow', function () {
          $(this).remove();
      })
      $('.konusan-user-sunum video').fadeOut('slow', function() {
        $(this).hide();
      })
      unload();
      
    })
    
    $('#test-print').on('click', function () {
      var template = $('#template-remote div').clone();
      console.log($(template).prop('outerHTML'));
    })
    
    $('#test-switch').on('click', function () {
      switchVideo();
    })

    $('.btn-container-toggle').on('click', function() {
      var targetcontainer = $(this).attr('id').replace('-toggle', '');
      $('.container-track.active').fadeOut('slow', function() {
          $('.container-track.active').toggleClass('active');
          $(`#${targetcontainer}`).fadeIn('slow').toggleClass('active');
      })
    })
  }

  sendMessage(pMessage) {
    SendMessageToAllParticipants(pMessage);
    this.message = "";
  }

  toggleVideo() {
    ToggleVideo();
  }

  ngOnDestroy(): void {
    unload();
  }
  
}

interface JitsiConnector{
  roomId:string;
  displayName:string;
  onConnectionSuccess();
  onConnectionFailed();
  onUserJoined(count: number);
  onUserLeft(count: number);
  onConferenceJoined(myId:string);
  onDisconnect();
  onRoomTrackAdded();
}
